import { render, staticRenderFns } from "./RemindOutingModal.vue?vue&type=template&id=f936554c&lang=pug"
import script from "./RemindOutingModal.vue?vue&type=script&lang=ts"
export * from "./RemindOutingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports